module.exports = __webpack_public_path__ + "static/media/DNU_KGH.413ec9f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Survey/images/DNU_KGH.jpg
// module id = 587
// module chunks = 0